export const OPTIONS_FREQUENCY = [
	{ label: 'Daily', value: 'date' },
	{ label: 'Weekly (Mondays)', value: 'week' },
	{ label: 'Execute Now', value: 'now' }
]

export const OPTIONS_EMBARGO_STATUS = [
	{ label: 'Met', value: 'Met' },
	{ label: 'Needs Action', value: 'Needs Action' },
	{ label: 'Not Met', value: 'Not Met' },
]

export const OPTIONS_INCLUDE_NEW_PRODUCTS = [
	{ label: 'Include all products', value: 'No' },
	{ label: 'Include only New products', value: 'Yes' }
]
